import React from "react";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";


const Search = styled("div")(({ theme, sx }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper, // Adjust the background color if needed
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    width: "auto",
  },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    paddingLeft: theme.spacing(2),
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));

export default function SearchBar({
  placeholder = "Search",
  inputProps = {},
  sx = {},
  data = [],
  onChange,
 
}) {
  const search = (input) => {
    const searchData = [];
    if (input) {
      data.map((value, index) => {
        let flag = true;
        Object.values(value).map((item) => {
          if (
            typeof item === "string" &&
            item.toLocaleLowerCase().startsWith(input.toLocaleLowerCase()) &&
            flag
          ) {
            searchData.push(value);
            flag = false;
          }
        });
      });
    }

    


    onChange(input === "" ? null:input !== "" &&searchData.length === 0?[] : searchData);
    
  };


  
 
  return (
    <Search>
      <StyledInputBase
        placeholder={placeholder}
        inputProps={{ "aria-label": "search", ...inputProps }}
        onChange={(e) => {
        
          search(e.target.value);
        }}
        sx={sx}
      />
    </Search>
  );
}
